module.exports = __webpack_public_path__ + "img/img_28.b90cf4f4.png";